module.exports = __webpack_public_path__ + "assets/img/Type E (6).d0619333.jpg";